<div
  #scroller
  class="canvas-scroller hide-scrollbar"
  style="position: absolute; width: 100%; height: 100%; overflow: auto"
  [style]="{
    cursor: isDragging() ? 'grabbing' : size()[0] > 1 && size()[1] > 1 ? 'grab' : size()[0] > 1 ? 'grab' : size()[1] > 1 ? 'grab' : 'auto',
  }"
  (dragstart)="(false)"
  (wheel)="$event.preventDefault()"
  (scroll)="$event.preventDefault()"
>
  <div
    style="position: absolute"
    [style]="{
      width: 100 * size()[0] + '%',
      height: 100 * size()[1] + '%',
      backgroundColor: '#1e2e6f',
    }"
  ></div>
</div>
